import AssetByClientAttributesChart from "./AssetByClientAttributesChart";
import AssetByEndDateChart from "./AssetByEndDateChart";
import AssetByManufacturerChart from "./AssetByManufacturerChart";
import AssetCategoryChart from "./AssetCategoryChart";
import InvoiceDetailsChart from "./InvoiceDetailsChart";

export enum ChartType {
    ASSET_CATEGORY = 'ASSET_CATEGORY',
    ASSET_MANUFACTURER = 'ASSET_MANUFACTURER',
    ASSET_CLIENT_ATTRIBUTES = 'ASSET_CLIENT_ATTRIBUTES',
    INVOICE_DETAILS = 'INVOICE_DETAILS',
    ASSET_END_DATE = 'ASSET_END_DATE'
}

export const CHART_TITLES: Record<ChartType, string> = {
    [ChartType.ASSET_CATEGORY]: "Assets by Category",
    [ChartType.ASSET_MANUFACTURER]: "Assets by Manufacturer",
    [ChartType.ASSET_CLIENT_ATTRIBUTES]: "Assets by Client Attributes",
    [ChartType.INVOICE_DETAILS]: "Invoice Details",
    [ChartType.ASSET_END_DATE]: "Assets by End Date"
};

export const CHART_COMPONENTS = {
    ASSET_CATEGORY: AssetCategoryChart,
    ASSET_MANUFACTURER: AssetByManufacturerChart,
    ASSET_CLIENT_ATTRIBUTES: AssetByClientAttributesChart,
    INVOICE_DETAILS: InvoiceDetailsChart,
    ASSET_END_DATE: AssetByEndDateChart
} as const;